"use client";

import React from "react";

import Picture from "@/components/ui-kit/Picture/Picture";
import { TextElementNova } from "@/components/ui-kit/TextElementNova/TextElementNova";
import { useLearning } from "@/context/NutrafolAcademyContext";

const ProductQuiz = () => {
  const { courses, currentStep, handleQuizComplete } = useLearning();
  const course = courses[currentStep];

  if (!course?.quiz) return null;

  return (
    <div className="w-full">
      <div>
        <TextElementNova
          text={course.quiz.question}
          className="Title-20-Super-Normal text-nova-base-white text-center mb-4 md:mb-10"
        />
      </div>
      <div className="grid grid-cols-4 gap-2 lg:gap-4 justify-center auto-rows-fr">
        {course.quiz.options.map((option, index) => (
          <button
            key={`quiz-option-${index}`}
            type="button"
            className="flex flex-col lg:flex-row col-span-2 items-center lg:text-left p-2 bg-nova-transparency-white-20 border border-nova-transparency-white-20 active:bg-nova-transparency-white-40 active:border-nova-brand-primary-80"
            aria-label={option.productName}
            onClick={() => handleQuizComplete(option)}
          >
            <Picture
              src={option.image}
              alt={option.productName}
              loading="lazy"
              className="w-[85px] lg:w-[130px] lg:min-w-[130px] aspect-[13/10] block"
            />
            <span>
              <TextElementNova
                text={option.productName}
                className="text-nova-base-white"
                classes={{
                  default: "Body-10-Dia-Normal",
                  1024: "Body-30-Dia-Normal",
                }}
              />
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ProductQuiz;
